import _ from 'lodash';
import d3 from './d3';
import chart from './linechart';
/**
 * This function is called to render a graphic by Pym.js. The frame's width and
 * a reference to the Pym instance is provided.
 *
 * @param  {Number} [frameWidth=600] The current width of the iframe, defaults
 *                                   to 600px to help with development
 * @param  {Object} pymChild         A reference to the IFrame's Pym instance
 * @return {void}
 */

const myChart = new chart()
let keys = Object.keys(window.DATA['Caseworker Turnover'][0]).slice(1)
let data = keys.map(id => ({
	id: id,
	values: window.DATA['Caseworker Turnover'].map(d => ({id: id, year: d['year'], value: d[id]}))
	
}))
myChart.create('#graphic', data, {
	xTickFormat: d => `${d3.timeFormat('%Y')(d)}`,
  yTickFormat: (d, i, o) => {
    if (i === o.length - 1) {
      return `${d3.format(".0%")(d)} turnover`
    }
    return d3.format(".0%")(d) 
  },
  yTickSteps: d3.range(0, 0.3, 0.05),
  xTickSteps: ["FY 2009", "FY 2013", "FY 2017"],
  tickOffset: 49,
  colors: ['#3FA293', '#F48B0B']
})


const resizeDb = _.debounce(() => {
  myChart.resize();
  // myMultiLineChart.resize();
}, 400);

window.addEventListener('resize', () => {
  resizeDb();
});

export default function renderGraphic(frameWidth, pymChild) {
  // Any code neccessary to render your graphic should be placed here - this
  // function is what is called in main.js by Pym

}
